import http from '../../baseUrl/HttpCommon';
import authHeader from '../authHeader/AuthHeader';

// 🔹 Get Mail Settings List
const getMailSettingsList = () => {
  return http.get('/Settings/MailSettingList', {
    headers: authHeader(),
  });
};

// 🔹 Save Mail Settings
const saveMailSettingsList = (data) => {
  return http.post('/Settings/MailSettingCreate', data, {
    headers: authHeader(),
  });
};

// 🔹 Get Mail Setting By Id (optional for Edit)
const getMailSettingsById = (id) => {
  return http.get(`/Settings/MailSettingEdit?id=${id}&type=edit`, {
    headers: authHeader(),
  });
};


const getMailSettingsByIdAdd = () => {
  return http.get(`/Settings/MailSettingEdit?id=0&type=add`, {
    headers: authHeader(),
  });
};

const MailSettingsService = {
  getMailSettingsList,
  saveMailSettingsList,
  getMailSettingsById,
  getMailSettingsByIdAdd,
};

export default MailSettingsService;
